const prefixes = [
  'ar',
  'cs',
  'da_DK',
  'de',
  'el',
  'en',
  'es',
  'et_EE',
  'fa',
  'fr',
  'he_IL',
  'hu_HU',
  'id_ID',
  'it',
  'ja',
  'ko',
  'ms_MY',
  'nl_NL',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk_SK',
  'sv',
  'th',
  'tr',
  'vi',
  'zh',
  'zh_TW',
];

export default prefixes;
